/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { ReduxUtils } from '@spm/core';
import { combineReducers } from 'redux';
import actionTypes from './actionTypes';
/**
 * Accesses message data from the store by reducing the whole store
 * of data down to just the messages slice of data.
 * @param {Object} state The initial state for the reducer.
 * @param {function} action The specified action creator.
 *
 * @returns The message data.
 */

export function messagesDataReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateReducer(state, action, actionTypes);
}
/**
 * Accesses a specific piece of data to indicate if mesages data is being fetched
 * from the store by reducing the whole store of data down to just the messages slice of data.
 *
 * @param {Object} state The initial state for the reducer.
 * @param {function} action The specified action creator.
 * @returns An indicator reflecting if the data of a feature is in the
 * process of being fetched.
 */

function isFetchingMessagesDataReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateFetchingReducer(state, action, actionTypes);
}
/**
 * Accesses messages error data from the store by reducing the whole store
 * of data down to just the messages error slice.
 *
 * @param {Object} state The initial state for the reducer.
 * @param {function} action The specified action creator.
 *
 * @returns The error messages encountered during the retrieval of messages.
 */


function messagesDataErrorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateErrorReducer(state, action, actionTypes);
}

var reducers = combineReducers({
  messagesData: messagesDataReducer,
  messagesDataError: messagesDataErrorReducer,
  isFetchingMessagesData: isFetchingMessagesDataReducer
});
export { reducers };